import React from "react"
import Link from "next/link"
import {SingleProductEnum} from "@/constants/commerce-enum"

interface CommentGuidelinesProps {
    mobile?: boolean
}

export function CommentGuidelines({mobile = false}: CommentGuidelinesProps) {
    return (
        <div
            className={`w-full text-sm rounded-xl text-black border p-4 ${mobile ? "text-xs leading-5" : "leading-6"}`}>
            لطفا پیش از ارسال دیدگاه، خلاصه قوانین زیر را مطالعه کنید:
            <br/>
            لازم است محتوای ارسالی منطبق برعرف و شئونات جامعه و با بیانی رسمی و عاری از لحن تند،
            تمسخرو توهین باشد.
            <br/>
            از ارسال لینک‌های سایت‌های دیگر و ارایه‌ی اطلاعات شخصی خودتان مثل شماره تماس، ایمیل و
            آی‌دی شبکه‌های اجتماعی پرهیز کنید.
            <br/>
            در نظر داشته باشید هدف نهایی از ارائه‌ی نظر درباره‌ی کالا ارائه‌ی اطلاعات مشخص و دقیق
            برای راهنمایی سایر کاربران در فرآیند خرید یک محصول توسط ایشان است.
            <br/>
            نکات مهم افزودن عکس و ویدیو به نظرات:
            <br/>
            ثبت یا مشخص بودن شماره تلفن، ‌آدرس، مشخصات شبکه‌های اجتماعی غیرمجاز است.
            <br/>
            <Link
                href="/terms"
                className="text-orange-primary mt-2 inline-block font-medium border-b border-orange-primary"
            >
                {SingleProductEnum.rulesAndRegulations}
            </Link>
        </div>
    )
}